import React from 'react';

import {DetailPageGenericPoliciesSidebar} from 'app/components/general/DetailPageGenericPoliciesSidebar';
import {
  convertLocationParamsToFetchParams,
  useAttachPolicyToProcedure,
  useDetachPolicyFromProcedure,
  usePolicies,
} from 'app/policies/api';

import type {RelatedPolicyType} from 'app/policies/types';
import type {ProcedureHashidSerializedType} from 'sweet-types';

type Props = {
  procedure: ProcedureHashidSerializedType;
  items: Array<RelatedPolicyType>;
  legacyRefetchData: () => Promise<unknown>;
};

export const ProcedurePoliciesSidebar = ({
  procedure,
  items,
  legacyRefetchData,
}: Props) => {
  const [attachPolicyToProcedure] = useAttachPolicyToProcedure();
  const [detachPolicyFromProcedure] = useDetachPolicyFromProcedure();
  return (
    <DetailPageGenericPoliciesSidebar
      attachedItems={items}
      closeUrl={procedure.html_url}
      detailPageObjectId={procedure.id}
      detailPageContentType={'procedure'}
      sidebarContentType={'policy'}
      showFilterField={procedure.can_edit}
      canEdit={procedure.can_edit}
      useDataHook={usePolicies}
      onAttach={(item) => {
        return attachPolicyToProcedure({
          genericLinks: [
            {
              policy: item.url,
              procedure: procedure.url,
            },
          ],
        })
          .unwrap()
          .then(() => legacyRefetchData());
      }}
      onRemove={(item) => {
        const linkedDocument = items.find(
          (attachedItem) => attachedItem.url === item.url
        );
        if (linkedDocument != null) {
          return detachPolicyFromProcedure(linkedDocument.link_url)
            .unwrap()
            .then(() => legacyRefetchData());
        }
        throw 'Linked document not found';
      }}
      paramsConverter={convertLocationParamsToFetchParams}
      legacyRefetchData={legacyRefetchData}
    />
  );
};
